<div class="children-horizontal-gap-4">
    <p class="fw-semibold">Select Reports</p>

    <div id="members">
        <app-multi-select-table [divID]="'members'" [tableSource]="source" [tableSettings]="settings" [preselected]="preselected" (rowSelected)="onRowSelect($event)"   [keyName]="'orgUserID'"></app-multi-select-table>
    
    </div>
</div>
